export default __webpack_public_path__ + "static/media/mozzeno.7f622a97.png";